export const meta = {
  title: '服务条款 | WordCraftApp',
  description:
    'WordCraftApp 下载指南、在线编辑器入口、基础教程和 Microsoft Word 对比的使用条款。',
  updated_at: '2026-10-15',
};

## 关于 WordCraftApp

WordCraftApp（“我们”）运营 wordcraftapp.com，是关于 WordCraft 的独立英文指南站。使用本站即表示你同意本条款。

本站提供：

- [下载指南](/download)：开发者发行版链接及安装步骤。
- [在线使用说明](/online)及[浏览器编辑器直达入口](/app/index.html)。
- [基础操作教程](/tutorials)：文档、格式、保存及导出的入门方法。
- [WordCraft 与 Microsoft Word 对比](/wordcraft-vs-microsoft-word)：区别、优势和局限。

这些指南和使用入口可免费访问，无需 WordCraftApp 账号。WordCraft 由 ArtCraft 开发，本站与 ArtCraft 或 Microsoft 无隶属、认可或赞助关系。

## WordCraft 软件

WordCraft 软件适用其自身的开源许可条款：MIT 或 Apache 2.0 许可证，以及适用的第三方声明。软件许可证与本站指南的使用条款相互独立。详情见 [WordCraft 仓库](https://github.com/storytold/wordcraft)、[MIT 许可证](/app/LICENSE-MIT)及 [Apache 许可证](/app/LICENSE-APACHE)。

## 在线编辑器与你的文档

托管的编辑器在浏览器中运行。你应对打开或创建的内容、使用权限以及保存工作负责。WordCraftApp 不提供文档云存储或备份服务。请单独备份重要文档，并在不同编辑器间交换文件后检查排版。

浏览器支持、软件功能和文件兼容性可能变化。在线编辑器可能更新或暂时无法访问，本站账号也不提供文档同步功能。

## 指南、教程与对比

我们努力使英文指南实用、准确。步骤和对比供参考，可能因版本、操作系统、浏览器或 Microsoft Word 版本而不同，不保证 WordCraft 能替代所有 Word 功能或保留每种文档排版。

安装或依赖某项功能前，请核对开发者的发行说明、系统要求和许可证。发现步骤或对比过时，可将页面地址发送至 [support@wordcraftapp.com](mailto:support@wordcraftapp.com)。

## 第三方链接

桌面版下载链接指向开发者的 GitHub Releases。第三方网站、社区和软件由各自提供者运营，并适用各自条款和隐私政策。我们无法控制其可用性或未来变更。

## 商标

Microsoft Word、Microsoft、ArtCraft 和 WordCraft 的名称与商标属于各自所有者。我们使用这些名称来识别软件、介绍用法及进行对比。软件许可证不会将商标所有权转移给本站或访客。

## 合理使用

请合法使用本站。请勿尝试未经授权的访问、通过网站功能传播恶意软件、干扰服务，或以滥用频率发送自动请求。使用可选账号时，请保护凭据；发现疑似未经授权的访问请通知我们。

## 可用性与责任

网站及指南按可用状态提供。在适用法律允许的范围内，我们不保证访问不会中断，也不保证内容完整、及时或适合某项具体任务。WordCraft 软件的保证及限制以其自身许可证为准。

在适用法律允许的范围内，WordCraftApp 不对使用本站导致的间接或后果性损失负责。本条款不排除法律不允许排除的权利或责任。

## 隐私

[隐私政策](/privacy-policy)说明网站数据、浏览器存储、可选账号及支持往来的处理方式。

## 变更与联系

我们可能随网站变化更新本条款，页面顶部的最后更新日期标识当前版本。

下载指南、失效链接、教程、对比或托管编辑器访问方面的问题，请联系 [support@wordcraftapp.com](mailto:support@wordcraftapp.com)。我们处理 WordCraftApp 网站相关问题；软件缺陷及开发需求可通过 WordCraft 仓库联系开发者。
